module.exports = __webpack_public_path__ + "static/media/Nutritionist.7f2d7dbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/HamburgerIcons/Nutritionist.svg
// module id = 570
// module chunks = 1